:host {
  display: block;
  max-width: 100%;
}

.title {
  color: var(--main-titles-inputs-600);
}

.sub-title {
  color: var(--chart-300-icon-buttons);
}

.grid-layout {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(60px, auto));
  grid-auto-rows: calc(var(--spacer) * 4);
}

gz-icon-label {
  display: inline-flex;

  &::part(icon) {
    margin-right: calc(var(--spacer) / 2);
    border-radius: 4px;
    min-width: 20px;
    min-height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &::part(label) {
    color: var(--body-text-arrows-400);
    font-size: var(--body-size);
    --font-family: var(--font-family-secondary-mono);
  }
}

gz-icon-label:hover {
  &::part(icon) {
    background-color: var(--chart-050-hover);
  }
}
